import { flow } from 'mobx-state-tree'
import { logger } from '@lusha/client-logger'
import { getCreditsBalance } from '../../../API/accountAssetsApi'
import Company from '../../Company'
import Contact from '../../Contact'
import Search from '../../Search'
import { delay } from '../../../utils/delay'

let latestCreditsRequest = 0

const Actions = self => ({
  fetchAccountCredits: flow(function* fetchAccountCredits(numberOfCreditsCharged = 0) {
    if (!envConfig.FEATURES?.FREE_TRIAL_POPUP) return
    try {
      const reqId = ++latestCreditsRequest;

      const totalCredits = self.totalCredits - numberOfCreditsCharged;

      if (totalCredits >= 0) {
        self.totalCredits = totalCredits
      }

      // We have a delay here because sometimes BE takes more then 5s to update values fot /balance API
      if (numberOfCreditsCharged) {
        yield delay(8000)
      }

      if (reqId !== latestCreditsRequest) return

      const res = yield getCreditsBalance()

      if (reqId !== latestCreditsRequest) return

      const { shared = [] } = res || {}
      self.accountCreditsTypes = shared

      shared?.forEach(({ totalUsed, total, type }) => {
        if (type !== 'email' && type !== 'phone') {
          self.totalCredits = total - totalUsed;
        }
      });
    } catch (err) {
      if (err.code !== 401) {
        logger.error('Failed to fetch account balances', {
          err,
          accountId: self.user?.accountId,
          userId: self.user?.id,
        })
      }
    }
  }),
  init: () => {
    if (self.isInitialized) return null
    self.contextCompany = Company.create({ id: 'contextCompany' })
    self.contextContact = Contact.create({ id: 'contextContact', company: self.contextCompany.id })
    self.prospecting = Search.create({ employee: self.contextContact.id })

    self.searchedCompany = Company.create({ id: 'searchedCompany' })
    self.employee = Contact.create({ id: 'employee', company: self.searchedCompany.id })
    self.search = Search.create({ employee: self.employee.id })
    self.isInitialized = true
  },
  resetSearchState: () => {
    self.searchedCompany = Company.create({ id: 'searchedCompany' })
    self.employee = Contact.create({ id: 'employee', company: self.searchedCompany.id })
    self.search = Search.create({ employee: self.employee.id })
  },
  addCompany: item => {
    const key = item.company_lid?.toString() || item.companyLid?.toString() || item.fqdn
    const company = Company.create({ id: key })
    company.setCompany(item)
    self.companies.set(key, company)
  },
  clearAllCompanies: () => {
    self.companies.clear()
  },
  setEmptyCompany: id => {
    self.companies.set(id, Company.create({ id }))
  },
})

export default Actions
